import {ChosenProductCategoryWatcher} from './ChosenProductCategoryWatcher.js';
import {ProductVariableSet} from './ProductVariableSet.js';

export class Terrahub {
	static init() {
		ProductVariableSet.init();
	}
}

document.addEventListener(`DOMContentLoaded`, function() {
	Terrahub.init();
});
